import React from 'react';
import { motion } from 'framer-motion';
import Button from '../ui/button';

interface Solution {
  icon: string;
  title: string;
  text: string;
  cta: {
    text: string;
    url: string;
  };
}

interface SolutionsSectionProps {
  title?: string;
  subtitle?: string;
  onOpenHubSpot: () => void;
}

export default function SolutionsSection({
  title = "Vos enjeux, ",
  subtitle = "Conseil RH, recrutement, IA, marque employeur… Nous repensons tout votre processus RH pour qu'il devienne un levier de performance et d'attractivité, même sans budget démesuré.",
  onOpenHubSpot
}: SolutionsSectionProps) {
  const solutions: Solution[] = [
    {
      icon: "🧲",
      title: "Attirez les bons candidats (sans chasser)",
      text: "Activez un processus interactif et engageant qui attire à vous les meilleurs talents. Fini les candidatures passives : vous valorisez votre culture et filtrez naturellement les profils alignés.",
      cta: {
        text: "🔎 Découvrir comment booster l'attractivité",
        url: "/entreprise/recrutement"
      }
    },
    {
      icon: "🎓",
      title: "Faites réussir vos nouvelles recrues",
      text: "On ne vous aide pas juste à recruter. On s'assure que vos nouveaux talents réussissent grâce à un onboarding structuré, des capsules de formation et des retours d'étonnement. Résultat : intégration accélérée et performance au rendez-vous.",
      cta: {
        text: "🎥 Voir un exemple de parcours",
        url: "/entreprise/onboarding"
      }
    },
    {
      icon: "🐷",
      title: "Transformez chaque recrutement en investissement",
      text: "Notre modèle économique innovant vous permet de recruter sans exploser vos budgets, en réduisant les risques, en anticipant les imprévus, et en maximisant le ROI RH.",
      cta: {
        text: "📊 Voir nos formules sans surprise",
        url: "/infos/tarifs"
      }
    }
  ];

  return (
    <section className="px-[5vw] xl:px-[100px] py-20 bg-white">
      <div className="text-center max-w-4xl mx-auto mb-16">
        <h2 className="section-title">
          Vos enjeux, <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d03484] to-[#d47254]">nos solutions</span>
        </h2>
        <p className="text-neutral-600 text-base sm:text-lg">{subtitle}</p>
      </div>

      <div className="grid gap-8 grid-cols-1 md:grid-cols-3 max-w-7xl mx-auto">
        {solutions.map((solution, index) => (
          <motion.div
            key={index}
            className="bg-white rounded-xl p-6 shadow-md flex flex-col justify-between"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <div>
              <div className="text-3xl mb-2">{solution.icon}</div>
              <h3 className="text-lg font-semibold mb-2 text-neutral-900">
                {solution.title}
              </h3>
              <p className="text-sm text-neutral-700">{solution.text}</p>
            </div>
            <div className="mt-4">
              <Button 
                variant="pink" 
                size="sm"
                onClick={() => window.location.href = solution.cta.url}
              >
                {solution.cta.text}
              </Button>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Ajout du bouton "Recrutement : nos tarifs" */}
     <div className="text-center mt-12">
  <a
    href="https://recruteurs.io/infos/tarifs"
    className="inline-block px-8 py-4 bg-[#d03484] hover:bg-[#c02e75] text-white text-lg font-semibold rounded-xl shadow-md transition"
  >
    💰 Recrutement : nos tarifs
  </a>
</div>
    </section>
  );
}